import React, { useState, useEffect } from 'react';
import { ContextualMenu } from '@cldf/scotiaweb-menu/lib/menu.es';
import { getAllInSession } from '@cldf/scotiaweb-customer-information';
import { navigate } from '../../../../../services/web.navigation';

const ROUTE = 'ROUTE';
const BALANCE_MOVEMENTS = 'Revisar saldos y movimientos';
const DEFERRED_BALANCE = 'Consulta giro diferido';
const HISTORICAL_MOVEMENTS = 'Ver cartola histórica';
const DEFERRED_BALANCE_ROUTE = '#consulta-giro-diferido';

const mutualFundContextualMenu = [
  {
    label: 'Ver cartola de Fondos mutuos',
    type: ROUTE,
    target: '#cartola',
  },
  {
    label: 'Rescatar Fondos mutuos',
    type: ROUTE,
    target: '#rescate-fondos-mutuos',
  },
  {
    label: 'Tomar Fondos mutuos',
    type: ROUTE,
    target: '#toma-fondos-mutuos',
  },
];

const termDepositContextualMenu = [
  {
    label: 'Consultar depósito',
    type: ROUTE,
    target: '#resumen-inversiones',
  },
  {
    label: 'Cancelar depósito',
    type: ROUTE,
    target: '#cancela-depositos',
  },
]; 

const creditCardContextualMenu = [
  {
    label: 'Ver saldo y estado de cuenta',
    type: ROUTE,
    target: '#mfe/mfe-simple-account-statement-web-cl?tab=saldo',
  },
  {
    label: 'ON/OFF Tarjeta de crédito',
    type: ROUTE,
    target: '#tarjetas/onoff',
  },
];

const personalLoanContextualMenu = [
  {
    label: 'Consultar resumen de crédito',
    type: ROUTE,
    target: '#credito/resumen-deudas',
  },
  {
    label: 'Pagar cuota',
    type: ROUTE,
    target: '#pago-cuota-credito',
  },
];


export const navigationResolver = (type, target) => ({
  onClick: () => {
    /* istanbul ignore next */
    navigate(target);
  },
});
const basicMenu = [
  {
    label: 'Actualizar datos',
    type: ROUTE,
    target: '#mfe/mfe-kyc-web-cl/',
  },
  {
    label: 'Cartola oficial por mail',
    type: ROUTE,
    target: '#cartola-oficial-email',
  },
  {
    label: 'Cambiar clave ScotiaWeb',
    type: ROUTE,
    target: '#cambiaclave',
  },
];

export const SummaryContextMenu = props => {
  const [inputStateMenu, setStateMenu] = useState(basicMenu);

  const _getSession = () => {
    getAllInSession().then(session => {
      if (
        session.T24800 !== undefined &&
        basicMenu.find(elem => elem.label === 'Revisar tus ScotiaPesos') === undefined
      )
        { 
          basicMenu.push({
          label: 'Revisar tus ScotiaPesos',
          type: ROUTE,
          target: '#mfe/mfe-loyalty-web-cl',
        });
        setStateMenu([...basicMenu]);
      }
    });
  };

  useEffect(() => {
    _getSession();
  }, []);

  return (
    <div>
      {props.productType === 'checking_account' && (
        <ContextualMenu
          menu={[
            {
              label: BALANCE_MOVEMENTS,
              type: ROUTE,
              target: `#mfe/mfe-accounts-balancesmovements-web/param/saldos--${padStartFormat(props.account)}`,
            },
            {
              label: HISTORICAL_MOVEMENTS,
              type: ROUTE,
              target: `#mfe/mfe-accounts-balancesmovements-web/param/cartolas--${padStartFormat(props.account)}`,
            },
            {
              label: 'Consultar cheques y talonarios',
              type: ROUTE,
              target: `#mfe/mfe-accounts-balancesmovements-web/param/cheques`,
            },
            // If it is a dollar account ...
            ...(props.currencyCode === 'USD'
              ? [
                  {
                    label: 'Compra y Venta de Dólares',
                    type: ROUTE,
                    target: `#mfe/mfe-currency-exchange-web-cl`,
                  },
                ]
              : []),
          ]}
          navigationResolver={navigationResolver}
          context={{}}
        />
      )}
      {props.productType === 'line_of_credit' && (
        <ContextualMenu
          menu={[
            {
              label: BALANCE_MOVEMENTS,
              type: ROUTE,
              target: `#cuentas/02000/${padStartFormat(props.account)}/saldo`,
            },
            {
              label: 'Pagar Línea de crédito',
              type: ROUTE,
              target: '#cuentas/pago',
            },
            {
              label: 'Liquidación de intereses',
              type: ROUTE,
              target: '#liquidacion-intereses',
            },
            {
              label: HISTORICAL_MOVEMENTS,
              type: ROUTE,
              target: `#cuentas/02000/${padStartFormat(props.account)}/cartola`,
            },
          ]}
          navigationResolver={navigationResolver}
          context={{}}
        />
      )}
      {props.productType === 'saving_account' && (
        <ContextualMenu
          menu={[
            {
              label: BALANCE_MOVEMENTS,
              type: ROUTE,
              target: `#cuentas/06000/${props.account
                .toString()
                .trim()
                .padStart(20, '0')}/saldo`,
            },
            {
              label: DEFERRED_BALANCE,
              type: ROUTE,
              target: DEFERRED_BALANCE_ROUTE,
            },
          ]}
          navigationResolver={navigationResolver}
          context={{}}
        />
      )}
      {props.productType === 'debit_account' &&
        props.productName !== 'Cuenta Renta Diaria' &&
        props.productName !== 'Cuenta AFP - Beneficios' &&
        props.productName !== 'Cuenta Joven' && (
          <ContextualMenu
            menu={[
              {
                label: BALANCE_MOVEMENTS,
                type: ROUTE,
                target: `#cuentas/32000/${padStartFormat(props.account)}/saldo`,
              },
              {
                label: 'Ver cartola histórica',
                type: ROUTE,
                target: `#cuentas/32000/${padStartFormat(props.account)}/cartola`,
              },
              {
                label: 'Consultar tranferencias históricas',
                type: ROUTE,
                target: `#movimientos-cajero-automatico-cta-vista`,
              },
            ]}
            navigationResolver={navigationResolver}
            context={{}}
          />
        )}
      {props.productName === 'Cuenta Renta Diaria' && (
        <ContextualMenu
          menu={[
            {
              label: BALANCE_MOVEMENTS,
              type: ROUTE,
              target: `#cuentas/35000/${padStartFormat(props.account)}/saldo`,
            },
            {
              label: HISTORICAL_MOVEMENTS,
              type: ROUTE,
              target: `#cuentas/35000/${padStartFormat(props.account)}/cartola`,
            },
          ]}
          navigationResolver={navigationResolver}
          context={{}}
        />
      )}
      {props.productName === 'Cuenta AFP - Beneficios' && (
        <ContextualMenu
          menu={[
            {
              label: BALANCE_MOVEMENTS,
              type: ROUTE,
              target: `#cuentas/36000/${padStartFormat(props.account)}/saldo`,
            },
            {
              label: HISTORICAL_MOVEMENTS,
              type: ROUTE,
              target: `#cuentas/36000/${padStartFormat(props.account)}/cartola`,
            },
          ]}
          navigationResolver={navigationResolver}
          context={{}}
        />
      )}
      {
        props.productName === 'Cuenta Joven' && (
          <ContextualMenu
            menu={[
              {
                label: BALANCE_MOVEMENTS,
                type: ROUTE,
                target: `#cuentas/31000/${padStartFormat(props.account)}/saldo`,
              },
              {
                label: 'Ver cartola histórica',
                type: ROUTE,
                target: `#cuentas/31000/${padStartFormat(props.account)}/cartola`,
              },
              {
                label: 'Consultar tranferencias históricas',
                type: ROUTE,
                target: `#movimientos-cajero-automatico`,
              },
            ]}
            navigationResolver={navigationResolver}
            context={{}}
          />
        )
      }
      {props.productType === 'credit_card' && (
        <ContextualMenu
          menu={[
            {
              label: 'Ver saldo y estado de cuenta',
              type: ROUTE,
              target: `#mfe/mfe-simple-account-statement-web-cl?tab=saldo&card=${formatCardLastNumbers(props.account)}`,
            },
            {
              label: 'ON/OFF Tarjeta de crédito',
              type: ROUTE,
              target: '#tarjetas/onoff',
            }
          ]}
          navigationResolver={navigationResolver}
          context={{}}
        />
      )}
      {props.productType === 'personal_loan' && (
        <ContextualMenu
          menu={personalLoanContextualMenu}
          navigationResolver={navigationResolver}
          context={{}}
        />
      )}
      {props.productType === 'mortgage' && (
        <ContextualMenu
          menu={[
            {
              label: 'Consultar resumen de crédito',
              type: ROUTE,
              target: '#credito/resumen-deudas',
            },
            {
              label: 'Pagar dividendo',
              type: ROUTE,
              target: `#mfe/mfe-mortgage-payment-web-cl/param/${props.account}`,
            },
            {
              label: 'Simular crédito',
              type: ROUTE,
              target: '#simular',
            },
          ]}
          navigationResolver={navigationResolver}
          context={{}}
        />
      )}
      {props.productType === 'term_deposit' && (
        <ContextualMenu
          menu={termDepositContextualMenu}
          navigationResolver={navigationResolver}
          context={{}}
        />
      )}
      {props.productType === 'mutual_fund' && (
        <ContextualMenu
          menu={mutualFundContextualMenu}
          navigationResolver={navigationResolver}
          context={{}}
        />
      )}
      {props.productType === 'user' && (
        <ContextualMenu menu={inputStateMenu} navigationResolver={navigationResolver} context={{}} />
      )}
    </div>
  );
};

function padStartFormat(value) {
  return value
    .toString()
    .trim()
    .padStart(20, '0');
}

const formatCardLastNumbers = (value) => {
  return value.toString()
  .split(' ')[1];
}
